import { render, staticRenderFns } from "./TopBasket.vue?vue&type=template&id=68e2a8db&scoped=true&"
import script from "./TopBasket.vue?vue&type=script&lang=js&"
export * from "./TopBasket.vue?vue&type=script&lang=js&"
import style0 from "./TopBasket.vue?vue&type=style&index=0&id=68e2a8db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e2a8db",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
